import { i18n } from '@js/i18n'
import { documentTypes } from '@const'

export default {
  form: {
    shortDescription: '',
    docs: {
      [documentTypes.fundLogo]: null
    }
  },
  requiredDocs: [documentTypes.fundLogo],
  rows: [
    [
      {
        "field": "input",
        "model": "shortDescription",
        "name": "blurb-description",
        "id":  "campaign-name",
        "maxlength": 250,
        "validate": "required",
        "required": true,
        "label": i18n.sale_description_label()
      }
    ],
    [
      {
        "field": "file",
        "fileType": "image",
        "fieldType": "campaignCreation",
        "id": "sale-blurb-image",
        "name": "sale-blurb-image",
        "type": documentTypes.fundLogo,
        "private": false,
        "label": i18n.sale_campaign_preview(),
        "required": true,
        "validate": "required"
      }
    ],
    [
      {
        "field": "textarea",
        "model": "shortDescription",
        "name": "blurb-description",
        "id":  "blurb-description",
        "maxlength": 250,
        "validate": "required",
        "required": true,
        "label": i18n.sale_description_label()
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/saleCreation/specs/step-2.blurb.schema.js